import React from 'react';
import { ArrowRight, Brain, Target, Lightbulb, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const reasons = [
  {
    icon: Brain,
    title: 'Deep AI Expertise',
    description: 'Years of hands-on experience in complex AI and data engineering projects.',
  },
  {
    icon: Target,
    title: 'Tailored Solutions',
    description: 'Customized, scalable services designed specifically to meet your unique business challenges.',
  },
  {
    icon: Lightbulb,
    title: 'Innovative Thinking',
    description: 'Leveraging the latest technologies to develop groundbreaking strategies.',
  },
  {
    icon: Users,
    title: 'Collaborative Partnership',
    description: 'Working side-by-side with our clients to ensure mutual success.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Why Choose Agility.AI Technologies?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Partner with us to transform your business through innovative AI solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 rounded-lg bg-gray-900/50 
                backdrop-blur-sm hover:bg-gray-900/70 transition-colors duration-300
                border border-gray-800/50 hover:border-gray-700/50 card-hover fade-in-up"
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center">
                  <reason.icon size={24} className="text-teal-400" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-2">{reason.title}</h3>
                <p className="text-gray-400">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* New CTA after Why Choose Us */}
        <div className="cta-container">
          <Link
            to="/contact"
            className="btn-primary"
          >
            <span>Partner with Us: Start Your AI Transformation</span>
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;